import { appConfig } from "../../insaweb.config";
import { findLast } from "@angular/compiler/src/directive_resolver";

export module customGroupHeader {
	let columnReorderEventInfo; // track column reorder events on grid
	// created the "move function to ease array manipulation
	interface Array<T> {
		move(from, to): void;
	}

	export function extendArray() {
		Object.defineProperty(Array.prototype, "move", {
			value: function (from, to) {
				this.splice(to, 0, this.splice(from, 1)[0]);
			},
			enumerable: false,
		});
	}

	export function getKendoGrid(gridID) {
		return $("#" + gridID).data("kendoGrid");
	}

	export function gridColumnReorder(e) {
		columnReorderEventInfo = e;
		e.sender.refresh();
	}

	export function KendoGridDataBound(arg) {
		try {
			// set correct colspans on grouping header row
			let gridID = "#" + arg.sender.element[0].id;
			let groupcount = getGroupCount(gridID);
			let colcount = arg.sender.columns.length;
			const gridContent = $(gridID).find(".k-grid-content");
			const savedScrollLeft = gridContent.scrollLeft();
			let grouprows = $(gridID)
				.find(".k-grouping-row")
				.each(function () {
					for (let td = 0; td < groupcount; td++) {
						if (this.children[td].colSpan > 1) {
							this.children[td].colSpan = groupcount - td;
						}
					}
				});
			//remove extra p elements created by kendo grid, probaby generated because of my messing aroung with DOM
			$("p:empty").remove();
			let grid = this;
			if (grid.dataSource.group().length > 0) {
				$(".k-grouping-row").each(function () {
					grid.collapseGroup(this);
				});
			}

			// Save Kendo's native sort indicators before autoFitColumn can wipe them
			const savedSortState: Array<{
				field: string;
				wasSorted: boolean;
				linkAppend: string;
				thAppend: string;
			}> = [];
			$(gridID)
				.find(".k-grid-header th.k-header[data-field]")
				.each(function () {
					const th = $(this);
					const field = th.attr("data-field");
					const link = th.find("a.k-link, span.k-link").first();
					const sortIconInLink = link.find(".k-sort-icon").prop("outerHTML") || "";
					const sortOrderInTh = th.find("> .k-sort-order").prop("outerHTML") || "";
					if (sortIconInLink || sortOrderInTh || th.hasClass("k-sorted")) {
						savedSortState.push({
							field: field,
							wasSorted: th.hasClass("k-sorted"),
							linkAppend: sortIconInLink,
							thAppend: sortOrderInTh,
						});
					}
				});

			//auto fit columns
			for (var i = 0; i < arg.sender.columns.length; i++) {
				arg.sender.autoFitColumn(i);
			}

			const headerTable = arg.sender.thead.closest("table");
			const wrapper = arg.sender.wrapper.find(".k-grid-header-wrap");
			const gridDataWidth = headerTable.width();
			const gridWrapperWidth =
				wrapper.innerWidth() || arg.sender.wrapper.width();
			const footerCols = arg.sender.footer
				? $(arg.sender.footer).find("colgroup > col")
				: $();
			if (gridDataWidth > 0 && gridWrapperWidth > gridDataWidth) {
				const tableCols = headerTable
					.find("colgroup > col")
					.add(arg.sender.table.find("colgroup > col"))
					.add(footerCols)
					.not(".k-group-col");
				const scaleFactor = gridWrapperWidth / gridDataWidth;
				let totalWidth = 0;
				tableCols.each(function () {
					const currentWidth = $(this).width();
					const newWidth = Math.floor(currentWidth * scaleFactor);
					$(this).css("width", newWidth + "px");
					totalWidth += newWidth;
				});

				const widthDelta = gridWrapperWidth - totalWidth;
				if (widthDelta > 0) {
					tableCols
						.last()
						.css("width", $(tableCols.last()).width() + widthDelta + "px");
				}
			}

			// Restore scroll position
			gridContent.scrollLeft(savedScrollLeft);

			// Restore Kendo's native sort indicators that autoFitColumn may have cleared
			savedSortState.forEach(function (saved) {
				const th = $(gridID).find(
					'.k-grid-header th[data-field="' + saved.field + '"]',
				);
				if (!th.length) {
					return;
				}
				if (saved.wasSorted) {
					th.addClass("k-sorted");
				}
				if (saved.linkAppend) {
					const link = th.find("a.k-link, span.k-link").first();
					th.find(".k-sort-icon").remove();
					(link.length ? link : th).append(saved.linkAppend);
				}
				if (saved.thAppend) {
					th.find("> .k-sort-order").remove();
					th.append(saved.thAppend);
				}
			});

			$(".k-grouping-row, p.k-reset").click(function () {
				var expanded = $(this).find(".k-i-collapse").length > 0;
				expanded
					? arg.sender.collapseGroup(this)
					: arg.sender.expandGroup(this);
			});

			//becuse we dont want to display aggregates in pivotviewer grid!
			if (gridID === "#PortfolioGrid") {
				var rows = grid.tbody.find("tr");
				for (var i = 0; i < rows.length; i++) {
					var dataRow = grid.dataItem(rows[i]);
					if (
						dataRow !== undefined &&
						dataRow["SecMainClass"] === appConfig.SecMainClass_LIQUIDITY
					) {
						//var currentRow = grid.table.find("tr[data-uid='" + currentUid + "']");
						//var data = grid.dataItem(row);
						var secChartButton = $(rows[i]).find(".k-grid-goToSecurityCommand");
						if (secChartButton.length) {
							secChartButton[0].hidden = true;
						}
					}
				}
				//var kendoDatagrid = getKendoGrid(gridID);
				//kendoDatagrid.resize();
				/*             arg.sender.options.height = $('.gridResize').height();
            arg.sender.resize(true);
 */
				//grid.refresh();
				//grid.resize();
			}

			//generic grid custom buttons
			$(".k-grid-edit").removeClass("k-button k-button-icontext");
			$(".k-grid-delete").removeClass("k-button k-button-icontext");

			//jobList grid custom buttons
			$(".k-grid-editJobBtn").attr("id", "editJobBtn");
			$(".k-grid-editJobBtn").removeClass("k-button k-button-icontext");

			$(".k-grid-deleteJobBtn").attr("data-toggle", "modal");
			$(".k-grid-deleteJobBtn").attr("data-target", "#modal_jobDelete");
			$(".k-grid-deleteJobBtn").attr("id", "deleteJobBtn");
			$(".k-grid-deleteJobBtn").removeClass("k-button k-button-icontext");

			//activity grid custom buttons
			$(".k-grid-editActivityBtn").attr("data-toggle", "modal");
			$(".k-grid-editActivityBtn").attr("data-target", "#modal_activityEdit");
			$(".k-grid-editActivityBtn").attr("id", "editActivityBtn");
			$(".k-grid-editActivityBtn").removeClass("k-button k-button-icontext");

			$(".k-grid-deleteActivityBtn").attr("data-toggle", "modal");
			$(".k-grid-deleteActivityBtn").attr(
				"data-target",
				"#modal_activityDelete",
			);
			$(".k-grid-deleteActivityBtn").attr("id", "deleteActivityBtn");
			$(".k-grid-deleteActivityBtn").removeClass("k-button k-button-icontext");

			$(".k-grid-postActBtn").attr("data-toggle", "modal");
			$(".k-grid-postActBtn").attr("data-target", "#modal_postActivityBtn");
			$(".k-grid-postActBtn").attr("id", "postActBtn");
			$(".k-grid-postActBtn").removeClass("k-button k-button-icontext");

			//postactions grid custom buttons
			$(".k-grid-editPostActBtn").attr("data-toggle", "modal");
			$(".k-grid-editPostActBtn").attr("data-target", "#modal_postActEdit");
			$(".k-grid-editPostActBtn").attr("id", "editPostActBtn");
			$(".k-grid-editPostActBtn").removeClass("k-button k-button-icontext");

			$(".k-grid-deletePostActBtn").attr("data-toggle", "modal");
			$(".k-grid-deletePostActBtn").attr("data-target", "#modal_postActDelete");
			$(".k-grid-deletePostActBtn").attr("id", "deletePostActBtn");
			$(".k-grid-deletePostActBtn").removeClass("k-button k-button-icontext");

			//reports grid custom button
			$(".k-grid-subReportBtn").attr("data-toggle", "modal");
			$(".k-grid-subReportBtn").attr("data-target", "#modal_subReports");
			$(".k-grid-subReportBtn").attr("id", "subReportBtn");
			$(".k-grid-subReportBtn").removeClass("k-button k-button-icontext");

			$(".k-grid-copyJobBtn").attr("data-toggle", "modal");
			$(".k-grid-copyJobBtn").attr("data-target", "#modal_jobCopy");
			$(".k-grid-copyJobBtn").attr("id", "copyJobBtn");
			$(".k-grid-copyJobBtn").removeClass("k-button k-button-icontext");
		} catch (err) {
			console.error("kentoInterop-scripts onDataBound error:" + err.message);
		}
	}

	export function getGroupCount(gridID) {
		let groupcount = $(gridID).find(
			".k-grid-content.k-auto-scrollable .k-group-col",
		).length;
		return groupcount;
	}

	export function getGroupInfo(aggregates, data, parentGrid) {
		try {
			// DN: prevent exception
			// customGroup-header.module.ts:120 kentoInterop-scripts getGroupInfo error:Cannot read property 'columns' of undefined
			if (
				parentGrid === undefined ||
				parentGrid === null ||
				parentGrid.columns === undefined
			) {
				return;
			}
			let columns = parentGrid.columns.slice();
			//if the grid columns are being reordered at the moment, take that into account when creating the group header
			if (columnReorderEventInfo !== undefined) {
				columns.move(
					columnReorderEventInfo.oldIndex,
					columnReorderEventInfo.newIndex,
				);
				columnReorderEventInfo = undefined;
			}

			let groupTemplate = "";
			//becuse we dont want to display aggregates in pivotviewer grid!
			let insaGrid: kendo.ui.Grid = $("#InsaGrid").data("kendoGrid");
			for (let i = 0; i < columns.length; i++) {
				if (i === 0) {
					let formatedValue = "";
					if (data.value !== null && data.value !== undefined) {
						const groupedColumn = columns.find(
							(col) => col.field === data.field,
						);
						if (
							groupedColumn &&
							groupedColumn.values &&
							groupedColumn.values.length > 0
						) {
							const lookupItem = groupedColumn.values.find(
								(v) => v.value == data.value,
							);
							formatedValue = lookupItem ? lookupItem.text : String(data.value);
						} else if (data.value instanceof Date) {
							formatedValue = kendo.toString(data.value, "dd.MM.yyyy");
						} else {
							formatedValue = String(data.value);
						}
					}
					groupTemplate +=
						'<td role="gridcell" style="text-transform:none;">' +
						formatedValue +
						"</td>";
				} else if (!columns[i].hidden && parentGrid !== insaGrid) {
					//display the aggregates
					if (
						columns[i].aggregates != null &&
						columns[i].aggregates.length > 0
					) {
						if (
							aggregates[columns[i].field] &&
							aggregates[columns[i].field][columns[i].aggregates[0]]
						) {
							if (columns[i].field === "PercentOfTotal") {
								groupTemplate +=
									'<td role="gridcell" style="text-align:right;">' +
									kendo.toString(
										aggregates[columns[i].field][columns[i].aggregates[0]],
										"n2",
									) +
									"%" +
									"</td>";
							} else {
								groupTemplate +=
									'<td role="gridcell" style="text-align:right;">' +
									kendo.toString(
										aggregates[columns[i].field][columns[i].aggregates[0]],
										"n2",
									) +
									"</td>";
							}
						} else {
							groupTemplate +=
								'<td role="gridcell" style="text-align:right;"></td>';
						}
					} else {
						//if no aggregates on the column, simply return the empty value for that group header col
						groupTemplate +=
							'<td role="gridcell"  style="text-align:right;"></td>';
					}
				}
			}

			return groupTemplate;
		} catch (err) {
			console.error("kentoInterop-scripts getGroupInfo error:" + err.message);
		}
	}
}



// WEBPACK FOOTER //
// ./app/insa-custom-scripts/customGroup-header.module.ts